import { useContext } from 'react';
import Logo from '../../../assets/CC ATS Logo Footer.png';
// import Logo from '../../../assets/Merry ATS Christmas (5).gif';
import { DContext } from '../../../context/Datacontext';

function Footer() {

    const { isAuth } = useContext(DContext)

    return (
        <footer className="bg-black text-white py-8">
            <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
                {/* Logo and Address */}
                <div className="flex items-center mb-6 md:mb-0">
                    <img src={Logo} alt="SAN Engineering Solutions" className="h-16 mr-4 object-contain rounded-lg" />
                    <div className="text-sm leading-relaxed">
                        <h3 className="font-bold uppercase">CC ATS</h3>
                        <p className='uppercase text-gray-400 font-medium'>
                            Recruitment Automation<br />
                            and tracking tool
                        </p>
                    </div>
                </div>
                {/* Quick Links */}
                <div>
                    <h4 className="text-lg font-semibold mb-2">Quick Links</h4>
                    <ul className="space-y-1">
                        <li>
                            <a href="/" className="text-gray-400 font-medium hover:text-gray-600 transition-colors text-sm">
                                {isAuth ? "Dashboard" : "Home"}
                            </a>
                        </li>

                        <li>
                            <a href="https://forms.gle/2PMVLAqgb2jwX2QAA" className="text-yellow-200 font-medium hover:text-gray-600 transition-colors text-sm">
                                Raise Tech Issue
                                {/* Technical Report */}
                            </a>
                        </li>

                        {/* <li>
                            <a href="/terms-condition" className="text-gray-400 font-medium hover:text-gray-600 transition-colors text-sm">
                                Terms & Conditions
                            </a>
                        </li>
                        <li>
                            <a href="/privacy-policy" className="text-gray-400 font-medium hover:text-gray-600 transition-colors text-sm">
                                Privacy & Policy
                            </a>
                        </li> */}
                    </ul>
                </div>
            </div>
            {/* Copyright */}
            <div className="mt-6 text-center text-xs text-gray-500 font-medium">
                &copy; 2025 <a className='font-bold text-gray-400' href='https://www.sanengineeringsolutions.com/'>SAN Engineering Solutions</a>. All rights reserved.
            </div>
        </footer>
    );
}

export default Footer;